// WhatsApp global notification settings API service
import apiClient from './api'

export interface WhatsAppGlobalConfig {
  id: string
  order_alerts_enabled: boolean
  payment_alerts_enabled: boolean
  inventory_alerts_enabled: boolean
  shipment_alerts_enabled: boolean
  document_alerts_enabled: boolean
  promotional_alerts_enabled: boolean
  max_messages_per_hour: number
  min_delay_between_messages_seconds: number
  max_retry_attempts: number
  retry_delay_minutes: number[]
  default_language: string
  updated_by: string
  updated_at: string
}

export type WhatsAppGlobalConfigUpdate = Partial<
  Pick<
    WhatsAppGlobalConfig,
    | 'order_alerts_enabled'
    | 'payment_alerts_enabled'
    | 'inventory_alerts_enabled'
    | 'shipment_alerts_enabled'
    | 'document_alerts_enabled'
    | 'promotional_alerts_enabled'
    | 'max_messages_per_hour'
    | 'min_delay_between_messages_seconds'
    | 'max_retry_attempts'
    | 'retry_delay_minutes'
    | 'default_language'
  >
>

export const whatsappConfigService = {
  getGlobalConfig: async (): Promise<WhatsAppGlobalConfig> => {
    const response = await apiClient.get('/admin/whatsapp/config')
    return response.data
  },

  updateGlobalConfig: async (data: WhatsAppGlobalConfigUpdate): Promise<WhatsAppGlobalConfig> => {
    const response = await apiClient.put('/admin/whatsapp/config', data)
    return response.data
  },
}
